import { el } from 'redom';

import TextInputBox from './text-input-box';
import TextArea from './textarea';

class TextAreaBox extends TextInputBox {

  constructor(configuration) {

    super(configuration);

    this.errored = false;

    this.input = new TextArea(configuration);

    this.error = this.renderError();

    this.el = el('.field-input-and-error', [
      this.input,
      this.error
    ]);

  }

}

export default TextAreaBox;